module.exports = __webpack_public_path__ + "static/img/tt.e1a3fdc.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/tt.gif
// module id = 6wN5
// module chunks = 1